import {
  EstadoCuadreENUM,
  gridSizeMdLg12,
  gridSizeMdLg3,
  gridSizeMdLg6,
  ROUTER_PATHS,
} from "@/shared";
import {
  CustomTextFieldNoForm,
  SampleCheckbox,
  SingleTableBoxScene
} from "@/shared/components/ui";
import { BODEGAS, IUbicacionProducto, Ubicaciones } from "@/shared/interfaces/erp/inventario";
import { ICuadreInventario } from "@/shared/interfaces/erp/inventario/cuadre-inventario.interface";
import { Button, Grid, Paper } from "@mui/material";
import FilterListIcon from '@mui/icons-material/FilterList';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import EmailModalCuadre from "../email-modal-cuadre/EmailModalCuadre";
import CustomAutocompleteFetchForm from "@/shared/components/ui/CustomAutocompleteFetchForm";
import { getUbicaciones } from "@/shared/actions/erp";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import { useUiStore } from "@/store/ui";
import { useNavigate } from "react-router-dom";
import useAutocompleteFetch from "@/shared/hooks/useAutocompleteFetch";
import dayjs from "dayjs";
import useCuadreInventario from "../../hook/useCuadreInventario";
import { useDetalleStore } from "../../hook/useDetalleStore.store";
import { CuadreModalSeries } from "../cuadre-modal-series/CuadreModalSeries";
import CustomAutocompleteMultipleArrStringNoForm from "@/shared/components/ui/CustomAutocompleteMultipleArrStringNoForm";
import { useCategoriaProductoStore } from "@/store/erp";



interface SaveCuadreInventarioProps {
  editCuadre?: ICuadreInventario
  label: string
}

export default function SaveCuadreInventario({
  editCuadre,
  label
}: SaveCuadreInventarioProps) {


  const {
    dataProductosEquipos,
    isLoadingProductoEquipos,
    isRefetchingProdEquipos,
    disableForm,
    columns,
    pagination,
    setPagination,
    //setDataCuadre,
    paramsProducto,
    paramsUbicaciones,
    form,
    fields,
    append,
    remove,
    setOpenEmailModal,
    openEmailModal,
    onSubmitHandler,
    setEnabled,
    onCargarProductosFiltrados,
    enabled,
    columnFilters,
    setColumnFilters,
    defaultCategoria,
    setDefaultCategoria
  } = useCuadreInventario({
    editCuadre
  })

  const categoriaNombre = useCategoriaProductoStore(s => s.categoriaNombre)
  const isLoadingCategoriaProducto = useCategoriaProductoStore(s => s.isLoadingCategoriaProducto)


  const {
    control,
    reset
  } = form

  const setConfirmDialog = useUiStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);
  const navigate = useNavigate();
  const interactions = useDetalleStore(s => s.interactions)
  const cleanCuadre = useDetalleStore(s => s.cleanCuadre)

  const {
    fetchAutocompleteUbicacion,
    fetchAutocompleteBodega,
    fetchAutocompleteUbicacionProducto
  } = useAutocompleteFetch()

  return (
    <>
      <SingleTableBoxScene
        title={label}
      >
        <Grid container
          spacing={1}
          justifyContent={'space-between'}>
          <Grid item {...gridSizeMdLg6}>

            <Grid
              container
              spacing={3}
            >
              <CustomTextFieldNoForm
                disabled
                size={gridSizeMdLg6}
                label="Fecha Cuadre"
                value={form.getValues('fecha_creacion')}
                defaultValue={form.getValues('fecha_creacion')}
              />

              <CustomAutocompleteFetchForm<BODEGAS, any, string>
                required={false}
                control={control}
                size={gridSizeMdLg6}
                disabled={disableForm}
                name="bodega"
                label="Bodega"
                fetchData={fetchAutocompleteBodega}
                isAll={false}
                getOptionLabel={(o) => o.nombre ?? '—'}
                getOptionKey={(o) => o.codigo!}
                onChangeValue={(e) => {
                  setEnabled(false)
                  reset({
                    ...form.getValues(),
                    estado: true,
                    ubicacion: null,
                    bodega: e
                  })
                }}
              />

              <CustomAutocompleteFetchForm<Ubicaciones, any, string>
                control={control}
                required={false}
                disabled={disableForm}
                size={gridSizeMdLg6}
                name="ubicacion"
                label="Ubicación"
                fetchParams={paramsUbicaciones}
                isAll={false}
                fetchData={fetchAutocompleteUbicacion}
                loadOptionByValue={async (codigo) => {
                  const res = await getUbicaciones({
                    codigo: codigo as string
                  });
                  return res?.data.data[0] ?? null;
                }}
                getOptionLabel={(opt) => opt.nombre || ''}
                getOptionKey={(o) => o.codigo!}
                onChangeValue={(e) => {
                  setEnabled(false)
                  reset({
                    ...form.getValues(),
                    estado: true,
                    ubicacion: e,
                  })
                }}
              />

              {
                !disableForm && (
                  <>
                    <CustomAutocompleteFetchForm<IUbicacionProducto, any, string>
                      name="producto"
                      disabled={disableForm}
                      required={false}
                      control={control}
                      label="Cod Producto"
                      fetchParams={paramsProducto}
                      size={gridSizeMdLg6}
                      keySearch="producto"
                      getOptionKey={(o) => o.producto!}
                      getOptionLabel={(o) => o.producto!}
                      isAll={true}
                      // options
                      fetchData={fetchAutocompleteUbicacionProducto}
                      onChangeValue={(e) => {
                        setEnabled(false)
                        reset({
                          ...form.getValues(),
                          estado: true,
                          producto: e,
                        })

                      }}
                    />



                  </>
                )
              }

              <CustomAutocompleteMultipleArrStringNoForm
                size={gridSizeMdLg12}
                required={isLoadingCategoriaProducto}
                label='Categoria'
                name='categoria'
                options={categoriaNombre ?? []}
                isLoadingData={false}
                defaultValue={defaultCategoria}
                helperText={false}
                textFieldKey={'categoria'}
                enableStringify={false}
                onChangeValue={(e) => {

                  setTimeout(() => {
                    setDefaultCategoria(e as string[])
                  }, 650);
                }}
              />

              <SampleCheckbox
                label="Productos con stock mayor a cero."
                name="con_stock"
                control={control}
                defaultValue={form.getValues().con_stock ?? true}
                size={gridSizeMdLg12}
              />



            </Grid>

          </Grid>

          {/* Acciones filtros */}

          {!disableForm && (
            <Grid item  {...gridSizeMdLg6}>

              <Grid container spacing={2}>
                <Grid item {...gridSizeMdLg6}>
                  <Button
                    fullWidth
                    variant="outlined"
                    startIcon={<FilterAltIcon />}
                    onClick={onCargarProductosFiltrados}
                  >
                    Cargar Productos Filtrados
                  </Button>
                </Grid>


                <Grid item {...gridSizeMdLg6}>
                  <Button
                    disabled={true}
                    fullWidth
                    variant="outlined"
                    startIcon={<FilterListIcon />}
                    onClick={() => {
                      setEnabled(true)

                    }}
                  >
                    Cargar todos los productos
                  </Button>
                </Grid>

                <Grid item {...gridSizeMdLg6}>
                  <Button
                    fullWidth
                    //disabled={!form.getValues().ubicacion}
                    variant="outlined"
                    onClick={() => {

                      setConfirmDialog({
                        isOpen: true,
                        title: '¡Confirmar!',
                        subtitle:
                          'Esta acción eliminará todos los filtros y la información ingresada. ¿Estás seguro de que deseas continuar?',
                        onClose() {
                          setConfirmDialogIsOpen(false);
                        },
                        onConfirm() {

                          setEnabled(false)
                          cleanCuadre()
                          reset({
                            fecha_creacion: dayjs().format('YYYY-MM-DD hh:mm'),
                            estado: false,
                          })
                          setConfirmDialogIsOpen(false);

                        },
                        cancelTextBtn: 'Cerrar',
                      });

                    }}
                  >
                    Limpiar Ventanta
                  </Button>
                </Grid>
              </Grid>

            </Grid>
          )}

          {/* Tables */}
          <Grid item xs={12}>

            <Paper>
              <SampleTablePagination<any>
                columns={columns}
                data={
                  enabled
                    ? dataProductosEquipos?.data.data as any ?? []
                    : []}

                ///* filtro
                enableColumnFilters={true}
                enableColumnActions={true}
                enableManualFiltering={true}
                columnFilters={columnFilters}
                onColumnFiltersChange={setColumnFilters}

                ///* paginacion
                rowCount={dataProductosEquipos?.data?.count ?? 0}
                setPagination={setPagination}
                pagination={pagination}
                rowNumber={true}
                isLoading={isLoadingProductoEquipos
                  || isRefetchingProdEquipos}
                muiTableBodyRowProps={({ row }: any) => {
                  const r = row.original;
                  const checked = (interactions[r.id_ubicacion_producto]?.check ?? false) === true;

                  return {
                    sx: checked
                      ? {
                        backgroundColor: "#A0C878"
                      }
                      : undefined,
                  };
                }}

              />
            </Paper>
          </Grid>

          {/* Acciones */}
          <Grid item {...gridSizeMdLg3}>
            <Button
              fullWidth
              variant="outlined"
              onClick={() => {
                navigate(ROUTER_PATHS.inventario.cuadreInventarioNav);
              }}
            >
              Cancelar
            </Button>

          </Grid>

          <Grid item {...gridSizeMdLg3}>

            <Button
              fullWidth
              variant="outlined"
              onClick={onSubmitHandler}
            >
              Guardar Borrador
            </Button>

          </Grid>

          <Grid item {...gridSizeMdLg3}>

            <Button
              fullWidth
              variant="outlined"
              color="success"
              onClick={async () => {

                form.setValue('estado_cuadre', EstadoCuadreENUM.FINALIZADO)
                setOpenEmailModal(true)
              }}
            >
              Guardar y enviar a flota
            </Button>
          </Grid>


        </Grid>

      </SingleTableBoxScene>

      <CuadreModalSeries />

      <EmailModalCuadre
        open={openEmailModal}
        setOpen={setOpenEmailModal}
        form={form}
        append={append}
        fields={fields}
        remove={remove}
        onSubmitHandler={onSubmitHandler}
      />


    </>

  )

}